// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ASK_AN_EXPERT = "Poradne";
export const FORUM = "Diskusie";
